export const VideoPluginID = 'video';
